import { render, staticRenderFns } from "./UploadProductsV2.vue?vue&type=template&id=654bb4d1&scoped=true&"
import script from "./UploadProductsV2.vue?vue&type=script&lang=js&"
export * from "./UploadProductsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654bb4d1",
  null
  
)

export default component.exports